{
  "title": "Detect Poison and Disease",
  "source": "Player's Handbook",
  "levelAndSchool": "1st-level divination (ritual)",
  "level": 1,
  "castingTime": "1 action",
  "range": "Self",
  "components": "V, S, M (a yew leaf)",
  "duration": "Concentration, up to 10 minutes",
  "description": [
    "For the duration, you can sense the presence and location of poisons, poisonous creatures, and diseases within 30 feet of you. You also identify the kind of poison, poisonous creature, or disease in each case.",
    "The spell can penetrate most barriers, but is blocked by 1 foot of stone, 1 inch of common metal, a thin sheet of lead, or 3 feet of wood or dirt."
  ],
  "spellLists": ["cleric", "druid", "paladin", "ranger"]
}
